import { render, staticRenderFns } from "./SystemBarBtn.vue?vue&type=template&id=76c8cff0&"
import script from "./SystemBarBtn.vue?vue&type=script&lang=js&"
export * from "./SystemBarBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports